require('./referralsFormWithEmail.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { PAGE_NAMES, tagReferralsLink, tagReferralsPage } = require('utilities/taggingReferralsHelper');
// @ commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
// @ components
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const WizardError = require('components/commons/wizardError/wizardError');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

class ReferralsFormWithEmail extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancelClick = this.handleCancelClick.bind(this);
        this.handleConfirmBtnClick = this.handleConfirmBtnClick.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        tagReferralsPage(this.getPageNameTag());
    }

    handleCancelClick() {
        this.tagLinkEvent('cancelar');
    }

    handleConfirmBtnClick() {
        const { onSubmit} = this.props;
        this.tagLinkEvent('Confirmar');
        onSubmit();
    }

    getPageNameTag() {
        const { immSendReferrals } = this.props;
        return `${PAGE_NAMES.CODE_SENDING_WITH_MAIL} ${immSendReferrals.get('promoCode')}`;
    }

    tagLinkEvent(linkName) {
        tagReferralsLink(this.getPageNameTag(), linkName);
    }

    isPreLeaveModalReady() {
        return false;
    }

    buildWizardError() {
        const goBackButton = {
            label: formatText('referrals-returnToInviteFriend').toUpperCase(),
            url: '/myprofile/referrals'
        };

        return (
            <div className="col-xs-offset-1 col-xs-10">
                <WizardError
                    errorMessage={formatText('referrals-errorStepTitle')}
                    mainButton={goBackButton}
                >
                    <FormattedText
                        value="referrals-errorStepText"
                    />
                </WizardError>
            </div>
        );
    }

    buildWizardSuccess() {
        const { email, handleReset, promotionTitle } = this.props;

        const goBackButton = {
            label: formatText('referrals-sendOtherCode').toUpperCase()
        };

        return (
            <div className="col-xs-offset-1 col-xs-10">
                <WizardSuccess
                    successMessage={formatText('referrals-successStepTitle', [promotionTitle])}
                    mainButton={goBackButton}
                    onMainButtonClick={handleReset}
                >
                    <FormattedText
                        value="referrals-successStepText"
                        injectedStrings={[email]}
                    />
                </WizardSuccess>
            </div>
        );
    }

    buildWizardWithEmail() {
        const { immSendReferrals, email } = this.props;

        const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
        const cancelText = formatText('wizard-redirectConfirmationCancelButton');
        const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
        const confirmationMessage = formatText('wizard-redirectConfirmationMessage');

        return (
            <div className="col-xs-12">
                <PreLeaveModalComponent
                    confirmationMessage={confirmationMessage}
                    confirmationTitle={confirmationTitle}
                    acceptText={acceptText}
                    cancelText={cancelText}
                    isReady={this.isPreLeaveModalReady}
                />
                <OKSectionBox>
                    <div className="row">
                        <div className="col-xs-12">
                            <h4 className="referrals-form-view__title">
                                <FormattedText value="referrals-sendCodePromotionTitle" />
                            </h4>
                            <p>
                                <FormattedText
                                    value="referrals-sendCodePromotionText"
                                    injectedStrings={[email]}
                                />
                            </p>
                            <footer className="referrals-form-view__footer">
                                <div className="referrals-form-view__cancel-button">
                                    <OKLink
                                        modifier="inherit-styles"
                                        onClick={this.handleCancelClick}
                                        to="/myprofile/referrals"
                                    >
                                        <FormattedText value="common-cancel" />
                                    </OKLink>
                                </div>
                                <OKButton
                                    onClick={this.handleConfirmBtnClick}
                                    loading={immSendReferrals.get('isFetching')}
                                >
                                    <FormattedText value="referrals-request" />
                                </OKButton>
                            </footer>
                        </div>
                    </div>
                </OKSectionBox>
            </div>
        );
    }

    render() {
        const { immSendReferrals } = this.props;

        let content;
        if (immSendReferrals.get('errorReceived')) {
            content = this.buildWizardError();
        }
        else if(immSendReferrals.get('submitSuccessful')) {
            content = this.buildWizardSuccess();
        } else {
            content = this.buildWizardWithEmail();
        }

        return content;
    }
}

ReferralsFormWithEmail.propTypes = {
    immSendReferrals: PropTypes.object.isRequired,
    email: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired,
    promotionTitle: PropTypes.string.isRequired,
    handleReset: PropTypes.func.isRequired,
};

module.exports = ReferralsFormWithEmail;
